import DIApi from './_diApi';

class ActivityAPI extends DIApi {
  controllerName = 'Activitys';
}

export default new ActivityAPI();
